module.exports = __webpack_public_path__ + "static/media/zach_levy_20220313_x512.8391c5bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zach_levy_20220313_x512.png
// module id = 46
// module chunks = 0